export default __webpack_public_path__ + "static/media/project.5d5ff459.png";